// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"b4da36f5","101":"8a14b45b","221":"3f45fbec","388":"de7235ff","439":"2db0aa67","636":"17bd44e3","838":"dd5024eb","859":"f4d87f0b"}[chunkId] + ".chunk.css";
};